import keys from './it.json';

export default {
  locale: 'it',
  messages: {
    ...keys,
    'RoundDateDisplay::format': `{ hasEnd, select,
            true {
              { preposition, select,
                at { il { end } }
                until { fino { end } }
              }
            }
            other { { duration, plural,
                one { # giorno }
                other { # giorni }
              }
            }
          }`,
    statusvalue: `{ roundNumber, select,
            0 {
              { content, select,
                Preview { In preparazione }
                Resolved { Concluso }
                other { {content} }
              }
            }
            other {
              { roundType, select,
                counteroffer_bidding { Controfferta }
                incremental_auction { Flessibile }
                open_bidding { Aperta }
                registration { Registrazione }
                sealed_bidding { Chiusa }
                simple_offer { Offerta digitale }
              }
              { roundStatus, select,
                opened { aperto }
                started { lanciato }
                closed { terminato }
                other { {roundStatus} }
              }
            }
          }`,
    'RoundInfo::label': `{ type, select,
              open_bidding { Aperta }
              sealed_bidding { Chiusa }
              incremental_auction { Flessibile }
              registration { Registrazione }
              simple_offer { Offerta digitale }
            }
            { status, select,
              started { non ancora aperta }
              opened
              {
                { hasEnd, select,
                  true {

                    { durationType, select,
                        fixed {
                          { isPreview, select,
                            true { inizia {startDuration} }
                            false {
                              { isPast, select,
                                false { ancora {endDuration} }
                                other { terminata }
                              }
                            }
                          }
                        }
                        flexible { il {durationInDays} giorni }
                    }
                  }
                  other {  }
                }
              }
              closed { si conclude { endText } }
              other { {status} }
            }`,
  },

  moment: {
    months:
      'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
        '_'
      ),
    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
      '_'
    ),
    weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'dddd D MMMM YYYY HH:mm',
    },
    calendar: {
      sameDay: '[Oggi alle] LT',
      nextDay: '[Domani alle] LT',
      nextWeek: 'dddd [alle] LT',
      lastDay: '[Ieri alle] LT',
      lastWeek: function () {
        switch (this.day()) {
          case 0:
            return '[la scorsa] dddd [alle] LT';
          default:
            return '[lo scorso] dddd [alle] LT';
        }
      },
      sameElse: 'L',
    },
    relativeTime: {
      future: function (s) {
        return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
      },
      past: '%s fa',
      s: 'alcuni secondi',
      ss: '%d secondi',
      m: 'un minuto',
      mm: '%d minuti',
      h: "un'ora",
      hh: '%d ore',
      d: 'un giorno',
      dd: '%d giorni',
      M: 'un mese',
      MM: '%d mesi',
      y: 'un anno',
      yy: '%d anni',
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/it.js